import { trackById } from 'src/app/shared/utils/track-by.util';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SEG } from 'src/app/models/seg.model';
import { ErrorConstants } from 'src/app/shared/constants/error.constants';

@Component({
  standalone: false,
  selector: 'app-associated-segs',
  templateUrl: './associated-segs.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./associated-segs.component.scss']
})
export class AssociatedSegsComponent implements OnInit {
  @Input() exposureAllSEGs: SEG[];
  @Input() loadingAllSEGs: boolean = true;
  
  errorMessage: string = "";

  constructor(
  ) {
    this.errorMessage = ErrorConstants.errorMessage;
  }

  ngOnInit(): void {
  }

  public trackById = trackById;
}
